<script setup>
import { defineProps, ref, watch, onMounted } from "vue"
import { latLng } from "leaflet"
import { LMap, LTileLayer, LMarker } from "@vue-leaflet/vue-leaflet"

const props = defineProps({
  customerLocation: {
    type: Array,
    default: () => null,
  },
})

const defaultLocation = latLng(35.72189246189307, 51.34966613117455)
const center = ref(defaultLocation)

onMounted(() => {
  if (props.customerLocation) {
    center.value = latLng(props.customerLocation)
  }
})

watch(
  () => props.customerLocation,
  (newVal) => {
    console.log("customerLocation:", newVal)
    if (newVal) {
      center.value = latLng(newVal)
    }
  },
  { immediate: true }
)

const zoom = ref(13)
const url = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
const attribution =
  '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
</script>

<template>
  <l-map :zoom="zoom" :center="center" style="height: 400px; width: 100%">
    <l-tile-layer :url="url" :attribution="attribution" />
    <l-marker v-if="center" :lat-lng="center" />
  </l-map>
</template>
